import { AppBar, Tabs, Tab, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { FC, useState, useMemo, useEffect } from 'react';
import { useParams, useHistory, useLocation } from 'react-router';
import { useQuery } from 'react-query';
import { Page, PageTitleWithBack, Loader } from '../../../../components';

import { HomeownerMessaging } from './homeowner-messaging';
import { PhotoUpload } from './photo-upload';
import { getBuildCommunicationInfo } from '../../../../fetch';

interface IBuildCommunicationsEdit {}

export const BuildCommunicationsEdit: FC<IBuildCommunicationsEdit> = () => {
  const classes = useStyles();
  const { buildId } = useParams<{ buildId: string }>();
  const history = useHistory();
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState(location.pathname);

  const { data: buildInfo, isLoading } = useQuery<{ headerInfo: string }, Error>(
    ['getBuildCommunicationInfo', buildId],
    () => getBuildCommunicationInfo(parseInt(buildId)),
    {
      notifyOnChangeProps: 'tracked'
    }
  );

  // Update selected tab when location changes
  useEffect(() => {
    setSelectedTab(location.pathname);
  }, [location.pathname]);

  const tabOptions = useMemo(
    () => [
      {
        name: 'Homeowner Messaging',
        url: `/production/build-communications/homeowner-messaging/${buildId}`
      },
      {
        name: 'Photo Upload',
        url: `/production/build-communications/photo-upload/${buildId}`
      }
    ],
    [buildId]
  );

  const handleChangeTab = (event: React.ChangeEvent<{}>, newValue: string) => {
    setSelectedTab(newValue);
    history.push(newValue);
  };

  const title = buildInfo?.headerInfo || 'Build Communications';

  if (isLoading) {
    return (
      <Page title="Loading...">
        <Loader type="inline" position="centered" />
      </Page>
    );
  }

  return (
    <Page title={title}>
      <>
        <PageTitleWithBack
          title={title}
          backText="Back to Build Communications"
          backUrl="/production/build-communications"
        />
        <AppBar position="static" color="default" component="div" className={classes.tabBar}>
          <Tabs
            value={selectedTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleChangeTab}
            variant="scrollable"
          >
            {tabOptions.map(tab => (
              <Tab
                value={tab.url}
                key={tab.name}
                id={`${tab.name.toLowerCase().replace(' ', '-')}-tab`}
                aria-controls={`${tab.name.toLowerCase().replace(' ', '-')}-panel`}
                label={tab.name}
              />
            ))}
          </Tabs>
        </AppBar>
        {location.pathname.includes('homeowner-messaging') && (
          <Typography component="div">
            <HomeownerMessaging buildId={parseInt(buildId)} />
          </Typography>
        )}
        {location.pathname.includes('photo-upload') && (
          <Typography component="div">
            <PhotoUpload buildId={parseInt(buildId)} />
          </Typography>
        )}
      </>
    </Page>
  );
};

const useStyles = makeStyles(theme => ({
  tabBar: {
    marginTop: '-1rem',
    backgroundColor: '#fff',
    boxShadow: 'none',
    borderBottom: `1px solid ${theme.palette.grey[400]}`
  }
}));
